import type { SVGProps } from "react";


interface RoundedAtTheRightRectProps extends SVGProps<SVGPathElement> {
    x: number;
    y: number;
    width: number;
    height: number;
    radius: number;
}


export function RightRoundedRect({
    x, y, width, height, radius, ...rest
}: RoundedAtTheRightRectProps) {
    const r = Math.min(width, radius);
    return (
        <path
            d={
                `M${x},${y} h${width - r} q${r},0 ${r},${r} v${height - 2 * r}`
                + ` q0,${r} ${-r},${r} h${-(width - r)} z`
            }
            {...rest} />
    );
}
